import { HttpService, MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { APPLICATION_ENDPOINTS } from '../constants/application-endpoints';
import { ThemeColor, ThemeService, ThemeTonalRange } from '@philips-internal/oswald-ui-components';

interface Theme {
  dsCorAccent: ThemeColor;
  dsCorAplicacao: ThemeColor;
  dsCorConteudo: ThemeTonalRange;
  dsCorLogin: ThemeTonalRange;
  dsCorNavegacao: ThemeTonalRange;
  dsLogoLogin: string;
  nmInstituicao: string;
  urlFavIcon: string;
}

function setupTheme(): Promise<Theme> {

  return HttpService.get(APPLICATION_ENDPOINTS.GET_CONFIGURATION,{})
    .then(async responseGetConfiguration => {
      let {
        dsCorAplicacao,
        dsCorNavegacao,
        dsCorLogin
      } = responseGetConfiguration.body as Theme;
      const { nmInstituicao, urlFavIcon } = responseGetConfiguration.body as Theme;
      const dsCorAccent = ThemeColor.AQUA;

      dsCorAplicacao = dsCorAplicacao || ThemeColor.GROUP_BLUE
      dsCorNavegacao = dsCorNavegacao || ThemeTonalRange.BRIGHT
      dsCorLogin = dsCorLogin || ThemeTonalRange.BRIGHT

      applicationContext.setTitle(nmInstituicao);

      setTimeout(() => {
        document.title = nmInstituicao || MessageService.translate('patient.home.title');
        const favIconLinkSmall = document.getElementById('fav-icon-small') as HTMLLinkElement;
        favIconLinkSmall.href = urlFavIcon || '/static/assets/icons/application-logo.svg';

        const favIconLinkLarge = document.getElementById('fav-icon-large') as HTMLLinkElement;
        favIconLinkLarge.href = urlFavIcon || '/static/assets/icons/application-logo.svg';
      },200);

      await ThemeService.setCustomColors(dsCorAplicacao, dsCorAccent);
      ThemeService.setContentTonalRange(dsCorLogin);
      ThemeService.setNavigationTonalRange(dsCorNavegacao);

      return responseGetConfiguration.body as Theme;
    });
}

export {
  setupTheme,
};